const DEFAULT_ICON = 'ndw-waze-other-new-25';

const ICON_BY_TYPE_AND_SUBTYPE: Record<string, Record<string, string>> = {
    ACCIDENT: {
        ACCIDENT_MINOR: 'ndw-waze-accident-new-25',
    },
    ROAD_CLOSED: {
        ROAD_CLOSED_CONSTRUCTION: 'ndw-waze-road-closed-new-25',
        ROAD_CLOSED_HAZARD: 'ndw-waze-road-closed-new-25',
        ROAD_CLOSED_EVENT: 'ndw-waze-road-closed-new-25',
    },
    HAZARD: {
        HAZARD_ON_ROAD_LANE_CLOSED: 'ndw-waze-lane-closed-new-25',
        HAZARD_ON_ROAD_CONSTRUCTION: 'ndw-waze-maintenance-new-25',
        HAZARD_WEATHER: 'ndw-waze-weather-dangerous-new-25',
        HAZARD_WEATHER_FOG: 'ndw-waze-weather-mist-new-25',

        HAZARD_WEATHER_FLOOD: 'ndw-waze-weather-rain-new-25',
        HAZARD_WEATHER_FREEZING_RAIN: 'ndw-waze-weather-rain-new-25',
        HAZARD_WEATHER_HAIL: 'ndw-waze-weather-rain-new-25',
        HAZARD_WEATHER_HEAVY_RAIN: 'ndw-waze-weather-rain-new-25',
        HAZARD_WEATHER_MONSOON: 'ndw-waze-weather-rain-new-25',

        HAZARD_WEATHER_HEAVY_SNOW: 'ndw-waze-weather-snow-new-25',
        HAZARD_WEATHER_HEAT_WAVE: 'ndw-waze-weather-heat-new-25',

        HAZARD_WEATHER_HURRICANE: 'ndw-waze-weather-wind-new-25',
        HAZARD_WEATHER_TORNADO: 'ndw-waze-weather-wind-new-25',

        HAZARD_ON_ROAD_CAR_STOPPED: 'ndw-waze-vehicle-stationary-new-25',
        HAZARD_ON_SHOULDER_CAR_STOPPED: 'ndw-waze-vehicle-stationary-new-25',
    },
};

export const getWazeIcon = (type: string, subType: string): string => {
    if (!type || !subType) {
        return DEFAULT_ICON;
    }

    return ICON_BY_TYPE_AND_SUBTYPE[type]?.[subType] ?? DEFAULT_ICON;
};
